<template>
  <div id="app">
    <header v-if="!isLoginPage" class="global-header">
      <div class="header-inner">
        <div class="logo-title">
          <img src="@/assets/rehabteach.png" alt="Logo" />
          <div class="platform-title">智能康复医学教学平台</div>
        </div>
        <nav class="nav-menu">
          <router-link to="/home" class="nav-item">Home</router-link>
          <router-link to="/about" class="nav-item">About</router-link>
        </nav>
      </div>
    </header>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed:{
    isLoginPage(){
      if(!this.$route || !this.$route.path){
        return false
      }
      return this.$route.path === '/login' || this.$route.path === '/register'
    }
  }
}
</script>

<style scoped>
.global-header{
  height: 60px;
  background-color:#409EFF;
  box-shadow: 0 2px 8px rgba(180,70,70,0.1);
}
.header-inner{
  height:100%;
  max-width:1400px;
  margin:0 auto;
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding:0 32px;
}
.logo-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.logo-title img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}
.platform-title {
  font-size: 20px;
  font-weight: 700;
  color: #b93c3c;
  letter-spacing: 1px;
}
.nav-menu{
  display:flex;
  gap:32px;
}
.nav-item{
  font-size:16px;
  color:#445668;
  text-decoration:none;
}
.nav-item:hover{
  color:#c24141;
}
</style>